// extracted by mini-css-extract-plugin
export default {"file_upload_guide_box":"file_upload_guide_box__887da1e5","divide_text":"divide_text__887da1e5"};